<ng-container *transloco="let t; read: 'error-snackbar'">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="flex-row gap-1 align-center">
      <app-value [value]="t('Error')" [bgFill]="true" [critical]="true"></app-value>
      <span class="error-message">{{ data.message }}</span>
    </div>
    <button mat-button (click)="dismiss()" color="accent">{{ t('Dismiss') }}</button>
  </div>
</ng-container>
